module.exports = __webpack_public_path__ + "static/media/chervi.868612ec.svg";